import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import './Header.css';
import { isLoggedIn } from '../../features/login/loginSlice';
import { selectMenuActive, toggleActive } from '../../features/menu/menuSlice';
import Menu from '../../features/menu/Menu';

import logo from '../../imgs/Transparent Logo.png';

export default function Header() {
    const dispatch = useDispatch();

    const loggedIn = useSelector(isLoggedIn);
    const menuActive = useSelector(selectMenuActive);

    const handleMenuClick = () => {
        dispatch(toggleActive());
    }

    return (
        <header className='landingPage'>
            <Link to={loggedIn ? '../home' : `../`}><img className="headerlogo" src={logo} alt='Minimalist logo of a wallet with a dollar sign next to the words "Knowledge Bank" and "Learn Your Money." The second phrase is below the first, a little smaller.'></img></Link>
            {loggedIn ? "" : <ul className='headerMenus'>
                <li>Pricing</li>
                <li>Features</li>
            </ul>}
            <div className='header-buttons'>
                {/* {loggedIn ? "" : <Link to={`../signup`}><button>Sign Up</button></Link>} */}
                {loggedIn ? <div className='profile-picture' onClick={handleMenuClick}>C</div> : <Link to={`../login`}><button>Login</button></Link>}
                {menuActive ? <Menu /> : ""}
            </div>
        </header>
    )
}